// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"28":"3b3f3408","118":"4ebcd6d3"}[chunkId] + ".css";
};